export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_07.799a13aa.jpg";